// extracted by mini-css-extract-plugin
export default {"container":"Demand__container-TYDh","expanded":"Demand__expanded-sm6O","unavailable":"Demand__unavailable-enu9"};